import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './SectionWrapper.module.scss';

function SectionWrapper({
  children,
  title,
  isRequired,
  className,
  ...rest
}) {
  return (
    <div className={classNames(styles.Component, className)} {...rest}>
      {title && (
        <span className={`Title ${isRequired ? 'require' : ''}`}>
          {title}
        </span>
      )}

      {children}
    </div>
  );
}

SectionWrapper.propTypes = {
  isRequired: PropTypes.bool,

  children: PropTypes.node,
  title: PropTypes.string,
  className: PropTypes.string,
};

SectionWrapper.defaultProps = {
  isRequired: false,

  children: null,
  title: '',
  className: '',
};
export default memo(SectionWrapper);
